import React, { useEffect } from "react";
import theme from "../../theme";
import { useAppSelector } from "../../redux";
import { selectTextDirection } from "../LanguageSelect/LanguageSelectSlice";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
// @ts-ignore
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import { type Direction, ThemeProvider, createTheme } from "@mui/material";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const rtlTheme = createTheme({ ...theme, direction: "rtl" });

export default function _DirectionHandler(props: { children: React.JSX.Element }) {
  const textDirection = useAppSelector(selectTextDirection);

  useEffect(() => {
    theme.direction = textDirection as Direction;
  }, [textDirection]);

  if (textDirection === "ltr") return props.children;
  else {
    return (
      <ThemeProvider theme={rtlTheme}>
        <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>
      </ThemeProvider>
    );
  }
}
